import { FolderPage } from '@frontend/features/documents/components/FolderPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/folder/$folderId/')({
  component: FolderPage,
});
